/* ========================================================================
   K-WORLDWIDE — THEME INIT
   v3.0 / district loading
   ========================================================================
   
   Gestisce:
   1. Time-of-day adaptive (5 fasce) automatico in base all'ora locale
   2. Override manuale utente (light/dark) salvato in localStorage
   3. Re-applicazione fascia quando l'utente cambia ora (es. tab aperta a lungo)
   
   No-flash di luce: viene eseguito INLINE in <head> prima di tutto il rendering.
   ======================================================================== */

(function () {
  'use strict';
  
  // ====== TIME-OF-DAY LOGIC ======
  
  /**
   * Restituisce la fascia oraria in base all'ora corrente locale.
   * Combacia esattamente con quanto definito in centralina v3 §1 e in kw-tokens.css
   */
  function getCurrentPhase() {
    var h = new Date().getHours();
    if (h >= 5  && h < 8)  return 'alba';      // 05:00 - 07:59
    if (h >= 8  && h < 18) return 'giorno';    // 08:00 - 17:59
    if (h >= 18 && h < 21) return 'tramonto';  // 18:00 - 20:59
    if (h >= 21 || h < 2)  return 'sera';      // 21:00 - 01:59
    return 'notte';                            // 02:00 - 04:59
  }
  
  /**
   * Applica la fascia oraria all'elemento <html>.
   * Se l'utente ha un override manuale, viene rispettato.
   */
  function applyPhase() {
    var root = document.documentElement;
    var override = null;
    
    try {
      override = localStorage.getItem('kw-tod-override');
    } catch (e) { /* localStorage disabled */ }
    
    if (override === 'light' || override === 'dark') {
      root.setAttribute('data-tod-override', override);
      root.removeAttribute('data-tod');
    } else {
      var phase = getCurrentPhase();
      root.setAttribute('data-tod', phase);
      root.removeAttribute('data-tod-override');
    }
  }
  
  /**
   * API pubblica per cambiare l'override.
   * Esposta come window.KW.setMode('auto' | 'light' | 'dark')
   */
  function setMode(mode) {
    try {
      if (mode === 'auto') {
        localStorage.removeItem('kw-tod-override');
      } else if (mode === 'light' || mode === 'dark') {
        localStorage.setItem('kw-tod-override', mode);
      }
    } catch (e) { /* localStorage disabled */ }
    applyPhase();
  }
  
  /**
   * Restituisce il mode corrente: 'auto', 'light', 'dark'
   */
  function getMode() {
    try {
      var override = localStorage.getItem('kw-tod-override');
      if (override === 'light' || override === 'dark') return override;
    } catch (e) { /* localStorage disabled */ }
    return 'auto';
  }
  
  /**
   * Restituisce la fascia corrente attiva sul DOM
   */
  function getPhase() {
    var root = document.documentElement;
    return root.getAttribute('data-tod') || root.getAttribute('data-tod-override') || 'giorno';
  }
  
  // ====== INIT ======
  
  applyPhase();
  
  // Re-applica ogni 15 minuti per gestire transizioni di fascia (es. tab aperta a lungo)
  if (typeof window !== 'undefined') {
    setInterval(applyPhase, 15 * 60 * 1000);
    
    // Re-applica al focus della tab (caso classico: laptop che si riapre dopo ore)
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) applyPhase();
    });
  }
  
  // ====== ESPOSIZIONE API PUBBLICA ======
  
  window.KW = window.KW || {};
  window.KW.setMode = setMode;
  window.KW.getMode = getMode;
  window.KW.getPhase = getPhase;
  window.KW.applyPhase = applyPhase;
  
  // Evento custom per altri script che vogliono ascoltare i cambi di fascia
  var lastPhase = getPhase();
  setInterval(function () {
    var current = getPhase();
    if (current !== lastPhase) {
      lastPhase = current;
      window.dispatchEvent(new CustomEvent('kw:phasechange', { detail: { phase: current } }));
    }
  }, 60 * 1000);
})();
